<highcharts-chart *ngIf="ischartLoaded" class="highcharts__renderer"
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [(update)]="updateChart"
  [oneToOne]="true"
  (resized)="HighChart.reflow()"
>
</highcharts-chart>

<mat-spinner diameter="30" class="spinnerCenter" *ngIf="!ischartLoaded"></mat-spinner>